import React from 'react';
import { Link } from 'react-router-dom';
import { getFactorLink } from '../../services/factorLinks';
import './TopFactors.css';

const TopFactors = ({ factors = [] }) => {
  const visibleFactors = Array.isArray(factors)
    ? factors.slice(0, 3)
    : [];

  if (visibleFactors.length === 0) {
    return null;
  }

  const maxContribution = Math.max(
    ...visibleFactors.map((factor) => Math.abs(Number(factor.contribution)))
  );

  return (
    <section className="top-factors" aria-label="What is driving your risk">
      <div className="top-factors__header">
        <h3 className="top-factors__title">What's driving your risk</h3>
        <p className="top-factors__intro">
          These answers had the strongest influence on your current risk score.
        </p>
      </div>

      <ul className="top-factors__list">
        {visibleFactors.map((factor) => {
          const contribution = Math.abs(Number(factor.contribution));
          const width = maxContribution > 0
            ? Math.max(12, Math.round((contribution / maxContribution) * 100))
            : 0;

          return (
            <li key={factor.question_code} className="top-factors__item">
              <Link
                to={getFactorLink(factor.question_code)}
                className="top-factors__link"
              >
                <span className="top-factors__label">{factor.label}</span>
                <span
                  className="top-factors__bar-track"
                  aria-label={`Relative weight ${contribution.toFixed(1)}`}
                >
                  <span
                    className="top-factors__bar-fill"
                    style={{ width: `${width}%` }}
                  />
                </span>
                <span className="top-factors__meta">
                  Weight {contribution.toFixed(1)}
                </span>
                {factor.rationale && (
                  <span className="top-factors__rationale">
                    {factor.rationale}
                  </span>
                )}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default TopFactors;
